import { checkAcl } from 'components/acl';
import { isEnvironment } from 'utils/environment';
import { CONTRACT_NOT_ANALYSED, CONTRACT_ANALYSED_NO_ISSUES, CONTRACT_ANALYSED_WITH_ISSUES } from '../charts/constants';

import type { Data } from '../types';

export const canSeeInsightTab = (workspace: Oneflow.Workspace) => checkAcl(workspace.acl, 'collection:ai_review:view_tab');
export const canSeeInsightContent = (workspace: Oneflow.Workspace) => checkAcl(workspace.acl, 'collection:ai_review:view');
export const canEditPlaybook = (workspace: Oneflow.Workspace) => checkAcl(workspace.acl, 'collection:ai_review:admin');
export const hasActivePlaybook = (workspace: Oneflow.Workspace) => workspace?.isAiReviewEnabled;
export const isExtensionEnabled = (account: Oneflow.Account) => Boolean(account.enabledExtensions?.find(({ key }: { key: string}) => key === 'ai_review'));

export const getTotalData = (insightsData: Data, totalDocumentsInQuery: number) => {
  const { filteredDocumentCount, filteredDocumentWithIssuesCount } = insightsData || {};
  const noIssuesCount = filteredDocumentCount - filteredDocumentWithIssuesCount;
  return {
    data: [
      {
        count: isEnvironment('development') ? 30 : filteredDocumentWithIssuesCount,
        isBreach: true,
        label: CONTRACT_ANALYSED_WITH_ISSUES,
      },
      {
        count: isEnvironment('development') ? 10 : noIssuesCount,
        isBreach: false,
        label: CONTRACT_ANALYSED_NO_ISSUES,
      },
      {
        count: isEnvironment('development') ? 5 : (totalDocumentsInQuery - filteredDocumentCount),
        isBreach: null,
        label: CONTRACT_NOT_ANALYSED,
      },
    ].filter((dataPoint) => dataPoint.count > 0),
    label: 'All',
    type: 'all',
  };
};
